function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.51562 2.71094L13.7656 7.58594C13.9766 7.79688 14.0703 8.125 13.9531 8.40625C13.8359 8.6875 13.5547 8.875 13.25 8.875H12.875V13C12.875 13.8203 12.1953 14.5 11.375 14.5H4.625C3.80469 14.5 3.125 13.8203 3.125 13V8.875H2.75C2.44531 8.875 2.16406 8.6875 2.04688 8.40625C1.92969 8.125 2.02344 7.79688 2.23438 7.58594L7.48438 2.71094C7.78906 2.42969 8.23438 2.42969 8.51562 2.71094ZM7.625 10C7.01562 10 6.5 10.5156 6.5 11.125V13.375H9.5V11.125C9.5 10.5156 9.00781 10 8.375 10H7.625Z",
  fill: "#636766"
});

function SvgDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date-picker-icon.c7d1e88f.svg";
export { ForwardRef as ReactComponent };